import './general.scss';